import React from 'react'
import { useParams } from 'react-router-dom'
import { Card, CardBody, CardHeader, Col, Form, Row } from 'react-bootstrap'

import Address from '@component/Address'
import Breadcrumb from '@component/Breadcrumb'
import Contact from '@component/Contact'
import Tabs from '@component/Tabs'

const breadcrumbItems = [
    { title: 'Dashboard', url: '/dashboard' },
    { title: 'Usuário', url: '/users' },
    { title: 'Cadastrar' }
]

const tabsItems = [
    {
        title: 'Contatos',
        count: null,
        conteudo: <Contact />,
        active: true
    },
    {
        title: 'Endereços',
        count: null,
        conteudo: <Address />,
    },
]


export default function UsersForm() {

    const { co_user } = useParams()

    return (

        <>
            <div className='header'>
                <h1 className='header-title'>
                    {co_user ? `Alterar usuário - #${co_user}` : `Cadastrar novo usuário`}
                </h1>
                <Breadcrumb breadcrumb={breadcrumbItems} />
            </div>

            <Row className='mb-3'>
                <Col>
                    <Card>
                        <CardHeader>
                            <h5 className='card-title mb-0'>Formulário de cadastrar do usuário</h5>
                        </CardHeader>
                        <CardBody>

                            <Row>
                                <Col lg='3'>
                                    <Form.Group>
                                        <Form.Label htmlFor='zipcode'>CEP</Form.Label>
                                        <Form.Control type='text' id='zipcode' name='zipcode' placeholder='Informe o CEP' />
                                    </Form.Group>
                                </Col>
                            </Row>

                        </CardBody>
                    </Card>
                </Col>
            </Row>

            <Row className='mb-3'>
                <Col>
                    <Card>
                        <CardBody>

                            <Contact />

                        </CardBody>
                    </Card>
                </Col>
            </Row>

            <Row className='mb-3'>
                <Col>
                    <Card>
                        <CardBody>

                            <Address />

                        </CardBody>
                    </Card>
                </Col>
            </Row>



            <Tabs data={tabsItems} />
        </>

    )
}